import React, { Component } from 'react';

var Login = React.createClass({
  handlerOnChage: function(element){
    this.setState({
      [element.target.name]: element.target.value,
      error: false
    })
  },
  handlerLogin: function(e){
    e.preventDefault();
    this.props.actionCheckLogin(this.state);
  },
  getInitialState: function(){
    return({
      login: '',
      pass: '',
      error: this.props.error
    });
  },
  componentWillReceiveProps: function(nextProps){
    if(this.props.error != nextProps.error){
      this.setState({error: nextProps.error})
    }
  },
  render: function(){
    return(
      <div>
        <div className="loginHeadline">Пожалуйста авторизуйтесь</div>
        <div className="UserList">
          <div className="User" >
            <form onSubmit={this.handlerLogin} className={"LoginForm" + (this.state.error ? ' error' : '')}>
              <input type="text" autoCapitalize="none" onChange={this.handlerOnChage} placeholder="Логин" name="login" />
              <input type="password" autoCapitalize="none" onChange={this.handlerOnChage} placeholder="Пароль" name="pass" />
              <input type='submit' className="SelectSpecialtiesOpen" onClick={this.handlerLogin} value="Войти" />
            </form>
          </div>
        </div>
      </div>
    );
  }
});

export default Login;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Login/index.jsx
 **/